module.exports = __webpack_public_path__ + "static/media/top_10_vertical_conteudos.26d89c86.jpg";